import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import { Button, ColourStateSolid, FlexGap, StackHorizontal } from '@ukpostbox/frontend-framework';
import { useFieldArray, useForm } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import React, { useEffect } from 'react';
import { StackedThumbnails } from '@ukpostbox/frontend-framework/lib/Components/Images/Thumbnails/StackedThumbnails';
import { useForwardingBatchProvider } from '../../Providers/ForwardingBatchProvider';
import { useSite } from '../../../_Global/Providers/SiteInterfaceProvider';
import { BatchMailItemEntryType } from '../../Types/ForwardingBatchTypes';
import { MapMailItemThumbnails } from '../../../Mailboxes/Components/Thumbnails/MapMailItemThumbnails';
import { MailPartTypeEnum } from '../../../Mailboxes/Components/Thumbnails/Types/ThumbnailTypes';
import { BatchMailItemEntryDescription } from '../MailItems/BatchMailItemEntryDescription';

const defaultMailItemDescription = {
	descriptionType: 1,
	description: '',
	quantity: 0,
	value: 0,
	commodityCode: null,
	countryOfManufacture: null,
};

function BatchMailItemEntry(props: BatchMailItemEntryType) {
	const { currentBatchData, DeleteMailItemDescription } = useForwardingBatchProvider();

	const { setPdfViewer } = useSite();

	const formMethods = useForm({
		mode: 'onChange',
		defaultValues: {
			[`items.[${props.mailItemIndex}].descriptions`]: props.descriptions
				? props.descriptions.map((description) => ({
						mailDescription: description,
					}))
				: { mailDescription: defaultMailItemDescription },
		},
	});

	const { fields, remove, append } = useFieldArray({
		control: formMethods.control,
		name: `items.[${props.mailItemIndex}].descriptions`,
		shouldUnregister: true,
	});

	const RemoveDescription = (descriptionId: number, index: number) => {
		if (descriptionId) {
			DeleteMailItemDescription(props.mailUuid, descriptionId);
		}

		remove(index);
	};

	const CheckMailItemsDocumentsOnly = () => {
		fields.forEach((el) => console.log(el));
	};

	useEffect(() => {
		formMethods.reset();
	}, [currentBatchData]);

	return (
		<div className={`forwarding-batch-item ${props.readOnly ? 'batch-read-only' : ''}`}>
			<div className='forwarding-batch-item-entry-title'>{props.trackingId}</div>
			<div
				className='forwarding-batch-item-entry'
				style={!formMethods.formState.isValid ? { border: '2px solid var(--alert-border)' } : {}}
			>
				<div className='forwarding-batch-item-entry-overview'>
					<StackedThumbnails>
						<MapMailItemThumbnails
							mailType={MailPartTypeEnum['Mail-Envelopes']}
							files={props.files}
							onClickCallback={(e, link) => {
								e.stopPropagation();
								setPdfViewer(true, link);
							}}
						/>
						<MapMailItemThumbnails
							mailType={MailPartTypeEnum['Mail-Contents']}
							files={props.files}
							onClickCallback={(e, link) => {
								e.stopPropagation();
								setPdfViewer(true, link);
							}}
							hideMissing
						/>
					</StackedThumbnails>
					<div className='forwarding-batch-item-entry-meta'>
						{fields.map((description: any, index: number) => (
							<BatchMailItemEntryDescription
								key={`mailDescription_${props.mailUuid}_${description.id}`}
								index={index}
								mailUuid={props.mailUuid}
								mailItemIndex={props.mailItemIndex}
								mailDescription={description.mailDescription}
								removable={fields.length > 1}
								removeDescriptionCallback={() =>
									RemoveDescription(description.mailDescription.id, index)
								}
								itemDocumentsOnlyCallback={() => CheckMailItemsDocumentsOnly()}
								readOnly={props.readOnly}
							/>
						))}

						{!props.readOnly && (
							<StackHorizontal gap={FlexGap.ExtraSmall}>
								<Button
									title='Add Contents'
									squared
									colour={ColourStateSolid.Primary}
									icon={faPlus}
									onClick={() => append({ mailDescription: defaultMailItemDescription })}
									disabled={props.readOnly}
								/>

								{props.removable && (
									<Button
										title='Remove from Batch'
										squared
										icon={faTrash}
										onClick={() => props.removeMailItem()}
										disabled={props.readOnly}
									/>
								)}
							</StackHorizontal>
						)}
					</div>
				</div>
			</div>
		</div>
	);
}

export { BatchMailItemEntry };
